// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".treeNodeList--ZoX-MAjM {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"treeNodeList": "treeNodeList--ZoX-MAjM"
};
export default ___CSS_LOADER_EXPORT___;
